export default __webpack_public_path__ + "static/media/logo-text-light-blue.a14ab20e.png";